import {
  vArray,
  vBoolean,
  vDate,
  vNonEmptyString,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'

export const dispatchInternalSchema = vObject({
  confirmationNumber: vNonEmptyString(),
  trackingNumber: vOptional(vString()),
})

export type DispatchInternalDTO = vOutput<typeof dispatchInternalSchema>

export const redispatchSchema = vObject({
  method: vOptional(vPicklist(['api', 'email'])),
})

export type RedispatchDTO = vOutput<typeof redispatchSchema>

export const updateTrackingNumberSchema = vObject({
  trackingNumber: vString(),
})

export type UpdateTrackingNumberDTO = vOutput<typeof updateTrackingNumberSchema>

export const confirmPickupSchema = vObject({
  confirmationNumber: vString(),
})

export type ConfirmPickupDTO = vOutput<typeof confirmPickupSchema>

export const dispatchErrorSchema = vObject({
  errorMessage: vString(),
})

export type DispatchErrorDTO = vOutput<typeof dispatchErrorSchema>

export const irisDispatchSchema = vObject({
  carrierId: vNonEmptyString(),
  requestId: vNonEmptyString(),
  fvBOL: vNonEmptyString(),
  schedulePickup: vBoolean(),
  mode: vOptional(vPicklist(['internal', 'manual', 'iris', 'email'])),
  beta: vOptional(vBoolean()),
  code: vOptional(vString()),
  ref1: vOptional(vString()),
  ref2: vOptional(vString()),
  ref3: vOptional(vString()),
  status: vOptional(
    vPicklist(['ok', 'error', 'pending', 'waiting', 'withdrew', 'retracted']),
  ),
  bolStatus: vOptional(vPicklist(['ok', 'pending', 'error'])),
  labelURL: vOptional(vString()),
  labelStatus: vOptional(vPicklist(['ok', 'pending'])),
  emailStatus: vOptional(
    vPicklist([
      'pending',
      'delivered',
      'bounced',
      'dropped',
      'deferred',
      'opened',
    ]),
  ),
  error: vOptional(vString()),
  errorType: vOptional(
    vPicklist(['whitelist', 'provision', 'support', 'external', 'internal']),
  ),
  requestDate: vOptional(vDate()),
  dispatchDate: vOptional(vDate()),
  bolURL: vOptional(vString()),
  bolPDFURL: vOptional(vString()),
  proNum: vOptional(vString()),
  pickupNum: vOptional(vString()),
  billTo: vOptional(
    vArray(
      vObject({
        accountnumber: vOptional(vString()),
        address: vOptional(vString()),
        address2: vOptional(vString()),
        booth: vOptional(vString()),
        city: vOptional(vString()),
        state: vOptional(vString()),
        postalCode: vOptional(vString()),
        country: vOptional(vPicklist(['US', 'CA', 'MX', 'USA', 'CAN', 'MEX'])),
        contactName: vOptional(vString()),
        contactPhone: vOptional(vString()),
        contactEmail: vOptional(vString()),
        company: vOptional(vString()),
      }),
    ),
  ),
  preferredLabelSize: vOptional(vString()),
  preferredLabelCount: vOptional(vNumber()),
  refNums: vOptional(
    vArray(
      vObject({
        type: vString(),
        value: vString(),
        unitIndex: vOptional(vNumber()),
      }),
    ),
  ),
  _id: vOptional(vString()),
  items: vOptional(
    vArray(
      vObject({
        itemId: vString(),
        refNums: vOptional(
          vArray(
            vObject({
              type: vString(),
              value: vString(),
            }),
          ),
        ),
      }),
    ),
  ),
  files: vOptional(
    vArray(
      vObject({
        type: vPicklist([
          'appointment confirmation',
          'authorization for special service',
          'bol',
          'contact time critical',
          'corrected bol',
          'customer-quote',
          'customs documents',
          'delivery photo',
          'delivery return receipt',
          'detention certificate',
          'dimension certificate',
          'dispatch-request',
          'dispatch-response',
          'freight forwarding delivery order',
          'inspection certificate',
          'inspection report',
          'invoice',
          'label',
          'label-combined',
          'letter of authority',
          'lumper certificate',
          'mtr',
          'nmfc certificate',
          'other',
          'packingSlip',
          'pickup photo',
          'proof of delivery',
          'quote',
          'reconsignment authorization',
          'refused delivery receipt',
          'signed bol',
          'tally record signature',
          'weight and research inspection',
          'weightCert',
          'weights and corrections',
          'weights and research photos',
          'BOL-request',
          'BOL-response',
          'commercial invoice',
        ]),
        subtype: vOptional(vPicklist(['freightview', 'carrier', 'shipper'])),
        url: vString(),
        uploadDate: vOptional(vDate()),
        itemId: vOptional(vString()),
        pieceIndex: vOptional(vNumber()),
        itemTrackingnumber: vOptional(vString()),
        mimeType: vOptional(vPicklist(['application/pdf', 'application/zpl'])),
      }),
    ),
  ),
  warnings: vOptional(
    vArray(
      vObject({
        type: vPicklist(['data-change', 'carrier', 'limited-availability']),
        message: vString(),
      }),
    ),
  ),
})
export type IrisDispatchDTO = vOutput<typeof irisDispatchSchema>
